import { Component, input, output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import type { Role } from '@/models/role.model';
import { ROLE_ICONS, ROLE_LABELS } from '@/models/role.model';

/**
 * Компонент выбора роли пользователя.
 * Показывается только если у пользователя есть несколько ролей.
 */
@Component({
  selector: 'app-role-selector',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './role-selector.component.html',
})
export class RoleSelectorComponent {
  activeRole = input.required<Role>();
  switchableRoles = input.required<Role[]>();

  roleChange = output<Role>();

  protected readonly ROLE_LABELS = ROLE_LABELS;
  protected readonly ROLE_ICONS = ROLE_ICONS;

  protected selectRole(role: Role): void {
    this.roleChange.emit(role);
    (document.activeElement as HTMLElement)?.blur();
  }
}
